<div class="treeViewList aa-scrollable-y aa-scrollbar"
     [style.width.px]="width"
     [style.height.px]="height">
    <aa-treeview [treeModel]="treeModel"
                 [hoverLeaves]="true"
                 (itemSelected)="onItemSelected($event)">
    </aa-treeview>
</div>
